(() => {
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
  if (window.__yurchakSignatureFitPeek) return;
  window.__yurchakSignatureFitPeek = true;

  const init = () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    document.querySelectorAll('.ysf-section__track').forEach(track => {
      if (track.dataset.yurchakDesktopDrag === 'true') return;
      if (!track.querySelector(':scope > .ysf-card:nth-child(5)')) return;
      track.dataset.yurchakDesktopDrag = 'true';

      let down = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      track.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') return;
        down = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-yurchak-dragging');
        track.setPointerCapture?.(event.pointerId);
      });

      track.addEventListener('pointermove', event => {
        if (!down) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 5) moved = true;
        track.scrollLeft = startScroll - delta;
      });

      const stop = event => {
        if (!down) return;
        down = false;
        track.classList.remove('is-yurchak-dragging');
        try { track.releasePointerCapture?.(event.pointerId); } catch (_) {}
      };

      track.addEventListener('pointerup', stop);
      track.addEventListener('pointercancel', stop);

      track.addEventListener('click', event => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => setTimeout(init, 0));
  window.addEventListener('resize', init, { passive: true });
})();
